import { Stack, Text, useToast } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import Result from "./ResultCell.tsx";
import { ResultModel } from "../models/ResultModel";

const ResultContext = React.createContext({
    results: Array<ResultModel>(), fetchResults: () => { }
})

export default function Results() {
    const [results, setResults] = useState<Array<ResultModel>>([])
    const toast = useToast()
    const fetchResults = async () => {
        const response = await fetch("/api/result")
        if (response!.status !== 200) {
            const errorDetail = await response.json()
            toast({
                position: 'top',
                title: `Eroare la vizualizare [${response!.status}]: `,
                description: errorDetail.detail,
                duration: 5000,
                status: 'error',
                variant: 'left-accent',
                isClosable: true,
            })
            return;
        }
        const results = await response.json() as Array<ResultModel>;
        setResults(results)
    }

    useEffect(() => {
        fetchResults();
    }, []);

    return <ResultContext.Provider value={{ results, fetchResults }}>
        <Stack align='center' spacing={3} p={3}>
            {results.length === 0 ? <Text>Nu ai încărcat nicio arhivă.</Text> :
                results.map(result => <Result key={result.id.toString()} {...result} />)}
        </Stack>
    </ResultContext.Provider>
}

